import { call, put, takeLatest } from "redux-saga/effects";
import {
  addNewImmigration,
  fetchAllImmigrations,
  fetchImmigration,
  updateImmigration,
} from "./immigrationApi";

import {
  addCurrentImmigrations,
  addNewImmigrationsStart,
  addNewLcaStart,
  getAllImmigrations,
  getAllImmigrationsStart,
  getAllImmigrationsSuccess,
  getCurrentEmployeeImmigration,
  getFailureImmigrations,
  successAllImmigrations,
  successGetCurrentEmployeeImmigration,
  updateImmigrationsStart,
} from "./immigrationSlice";
import { showToast } from "../../../components";

function* getAllImmigrationsSaga(action) {
  try {
    const response = yield call(fetchImmigration, action.payload);
    if (response.success) {
      yield put(getAllImmigrationsSuccess(response.data || {}));
    }
    // yield put(getAllPlacementsSuccess(placements));
  } catch (error) {
    console.error("Placements fetch error:", error);
    // yield put(getAllPlacementsFailure(error.message));
  }
}

function* addNewImmigrationSaga(action) {
  try {
    const { payload, navigate, uiid, coll, patchId, onSuccess, tPath,rsd,rsn } =
      action.payload;
    // console.log("submissionData", submissionData, "navigate", navigate);
    console.log("uiid",uiid);
    let response;
    if (uiid) {
      response = yield call(
        updateImmigration,
        uiid,
        patchId,
        coll,
        payload,
        tPath
      );
    } else {
      response = yield call(addNewImmigration, payload, coll, tPath);
    }
    if (response.success) {
      if (onSuccess) {
        onSuccess(response);
        if (uiid) {
          yield put(
            addCurrentImmigrations({
              [rsn]:{...rsd},
              uiid: response.data.data.lcaId,
              data:response.data.data.doc,
            })
          );
          // showToast(`update${rsn}`, "success", 5000);
          showToast(`Updated Successfully`, "success", 5000);
        } else {
          const activeArray = payload[tPath];
          yield put(
            addCurrentImmigrations({
              [rsn]:{...rsd},
               uiid: response.data.data.lcaId,
              data:response.data.data.doc,
            })
          );
          showToast(`Added Successfully`, "success", 5000);
        }
      }
    } else {
      //   yield put(addNewPlacementFailure(response.error));
    }
  } catch (error) {
      yield put(getFailureImmigrations(error))
    console.error("Add New Placement Error:", error);
    // yield put(addNewPlacementFailure(error.message));
  }
}


function* updateImmigrationSaga(action) {
  try {
    const { payload, navigate, uiid, coll, patchId, onSuccess,rsd,rsn } =
      action.payload;
    // console.log("submissionData", submissionData, "navigate", navigate);
    let response = yield call(updateImmigration, uiid, patchId, coll, payload);
    if (response.success) {
      if (onSuccess) {
        onSuccess(response);
      }
      if (uiid) {
          yield put(
            addCurrentImmigrations({
                [rsn]:{...rsd},
              uiid: response.data.data.lcaId,
                 data:response.data.data.doc,
            })
          );
        }
      showToast("update Immigration", "success", 5000);
      //   yield put(addNewPlacementSuccess(response.data));
      //   console.log('payload',payload);
      //   if(uiid){
      //     yield put(addCurrentPlacement(payload[0].value));
      //   }else{
      //   yield put(addCurrentPlacement({...payload,uiid:response?.data?.data?.placementId}));

      //   }
      //navigate("/placements");
    } else {
      //   yield put(addNewPlacementFailure(response.error));
    }
  } catch (error) {
    console.error("Add New Placement Error:", error);
    // yield put(addNewPlacementFailure(error.message));
  }
}
function*addNewLcaStartSaga(action){
  
}
function*getAllImmigrationSaga(action){
    const {rsn}=action.payload;
   try {
    const response = yield call(fetchAllImmigrations, action.payload);
    if (response.success) {
      yield put(successAllImmigrations({
      [rsn]:response?.data?.data||[]
      } || {}));
    }else{
       yield put(successAllImmigrations({
      [rsn]:[]
      } || {}));
    }
    // yield put(getAllPlacementsSuccess(placements));
  } catch (error) {
    console.error("Placements fetch error:", error);
    // yield put(getAllPlacementsFailure(error.message));
    yield put(getFailureImmigrations(error))
  }
}
function*getCurrentEmployeeImmigrationSaga(action){
    const {rsn}=action.payload;
   try {
    const response = yield call(fetchAllImmigrations, action.payload);
    if (response.success) {
      yield put(successGetCurrentEmployeeImmigration({
      [rsn]:response?.data?.data||[]
      } || {}));
    }else{
       yield put(successGetCurrentEmployeeImmigration({
      [rsn]:[]
      } || {}));
    }
    // yield put(getAllPlacementsSuccess(placements));
  } catch (error) {
    console.error("Placements fetch error:", error);
    // yield put(getAllPlacementsFailure(error.message));
    yield put(getFailureImmigrations(error))
  }
}
export function* watchFetchImmigration() {
  yield takeLatest(addNewImmigrationsStart.type, addNewImmigrationSaga);
  yield takeLatest(updateImmigrationsStart.type, updateImmigrationSaga);
  yield takeLatest(getAllImmigrationsStart.type, getAllImmigrationsSaga);
  yield takeLatest(addNewLcaStart.type,addNewLcaStartSaga);
  yield takeLatest(getAllImmigrations.type,getAllImmigrationSaga);
  yield takeLatest(getCurrentEmployeeImmigration.type,getCurrentEmployeeImmigrationSaga);


}
